<template lang="pug" src="./html/Gallery.pug"></template>

<script>
  import ContentBase from '../ContentBase'
  import VideoPlayer from '../../tools/video-player'

  export default {
    extends: ContentBase,
    beforeCreate: function () {
      this._data.focusIndex = 0
      this.v = []
      this.vByListItem = {}
    },
    mounted () {
      this.setupVideo('sir-john-hegarty-dinner', '315602268', 'https://player.youku.com/embed/XNDA1MDAyNzMxMg==')
      this.setupVideo('wechat-integrated-robot-cafe', '315603408', 'https://player.youku.com/embed/XNDA1MDAyODg4MA==')
      this.setupVideo('halloween-bbh', '315602199', 'https://player.youku.com/embed/XNDA1MDAyNzI0MA==')
      this.setupVideo('skII-future-smart-store-installation', '315603068', 'https://player.youku.com/embed/XNDA1MDAyODE2OA==')
      this.setupVideo('sh-adidas-half-marathon-2018', '267007192', 'https://player.youku.com/embed/XNDAxNDU2NjI4NA==')
      this.setupVideo('fitfam-empty-streets-run', '315602084', 'https://player.youku.com/embed/XNDA1MDAyNzExNg==')
      this.setupVideo('wukang-mansions', '315603846', 'https://player.youku.com/embed/XNDA1MDAyOTAxMg==')
      this.setupVideo('digital-drinks-yext-video-invite', '315601703', 'https://player.youku.com/embed/XNDA1MDAyNjYyNA==')
      this.setupVideo('f45-xuhui-workout', '315601817', 'https://player.youku.com/embed/XNDA1MDAyNjgyMA==')
      this.setupVideo('anji-trip-2017', '315622851', 'https://player.youku.com/embed/XNDA1MDAyNTA5Ng==')
      this.setupVideo('arctic-tough-viking', '315804689', 'https://player.youku.com/embed/XNDA1MDk0NTUwMA==')
      this.setupVideo('taipei-user-personas', '342990168', 'https://player.youku.com/embed/XNDIzNTA5OTYzMg==')
      this.setupVideo('taipei-raohe-night-market', '342997334', 'https://player.youku.com/embed/XNDIzNTA5OTkzMg==')
      this.setupVideo('taipei-recap', '343000977', 'https://player.youku.com/embed/XNDIzNTEwMDAyNA==')
      window.addEventListener('scroll', this.onScroll)
      window.addEventListener('resize', this.onScroll)
    },
    beforeDestroy () {
      window.removeEventListener('scroll', this.onScroll)
      window.removeEventListener('resize', this.onScroll)
      for (let i = 0; i < this.v.length; i++) {
        if (this.v[i]) this.v[i].destroy()
      }
    },
    methods: {
      setupVideo (ref, vimeo, iframe) {
        let p = VideoPlayer(this.$refs[ref], vimeo, iframe)
        this.v.push(p)
        let index = this.$refs[ref].parentNode.parentNode.parentNode.getAttribute('itemIndex')
        if (!this.vByListItem[index]) this.vByListItem[index] = []
        this.vByListItem[index].push(p)
      },
      onScroll () {
        let fi = this._data.focusIndex
        let prev = this.getScore(fi - 1)
        let curr = this.getScore(fi)
        let next = this.getScore(fi + 1)
        if (prev) {
          fi = prev.index
        } else if (curr) {
        } else if (next) {
          fi = next.index
        } else {
          fi++
        }
        if (this._data.focusIndex !== fi) {
          if (this.vByListItem[this._data.focusIndex]) {
            for (let p of this.vByListItem[this._data.focusIndex]) {
              p.pause()
            }
          }
          this._data.focusIndex = fi
        }
      },
      getScore (i) {
        if (i >= 0 && i < this.$refs.mainList.childNodes.length) {
          let li = this.$refs.mainList.childNodes[i]
          let r = li.getBoundingClientRect()
          let v = (r.height + r.y) - (window.innerHeight >> 1)
          if (v < 0) {
            return null
          } else {
            return {
              index: i,
              value: v
            }
          }
        } else {
          return null
        }
      }
    }
  }
</script>

<style lang="sass" src="./style/Gallery.sass"></style>
